import * as types from '../types/topTypes';

const initialState = {
  items: [],
  source: '',
  loading: false,
  error: null,
};

export default function topReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TOP_REQUEST:
      return { ...state, loading: true, error: null, items: [] };
    case types.FETCH_TOP_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload?.items || [],
        source: action.payload?.source || '',
      };
    case types.FETCH_TOP_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
